export const config = {
    headerImg: require('@/assets/images/AISmartManagement/header.png'),
    headerTitle: 'AI智慧管理',
    headerDesc: '随着医院精细化管理和智慧运营建设的持续推进，围绕人、财、物、业务运行形成了大量结构化数据，运营管理系统的覆盖范围不断扩大。但在实际管理过程中，数据的存在并不等同于管理能力的提升，医院在运营分析与管理决策中仍普遍面临挑战。',
    content: [
        {
            src: require('@/assets/images/AISmartManagement/content1.png'),
            title: '医院运营管理痛点概述',
            info: '随着医院精细化管理和智慧运营建设的持续推进，围绕人、财、物、业务运行形成了大量结构化数据，运营管理系统的覆盖范围不断扩大。但在实际管理过程中，数据的存在并不等同于管理能力的提升，医院在运营分析与管理决策中仍普遍面临挑战。'
        },
        {
            src: require('@/assets/images/AISmartManagement/content2.png'),
            title: 'AI 运营助理：医院运营管理的智能入口与分析助手',
            info: '通过自然语言交互与智能分析能力，帮助管理者更高效地获取运营信息、理解运营变化、聚焦管理重点。将复杂的数据查询与分析过程转化为符合管理习惯的交互方式，AI 运营助理成为连接“运营数据”与“管理决策”的重要桥梁。'
        },
        {
            src: require('@/assets/images/AISmartManagement/content3.png'),
            title: 'AI 运营助理总体架构设计，深度嵌入智慧运营平台的智能能力组件',
            info: ''
        },
        {
            src: require('@/assets/images/AISmartManagement/content4.png'),
            title: '典型管理场景下的智能响应机制与多维度分析输出形式',
            info: ''
        },

    ],
    bottom: {
        title: '典型管理场景下的智能响应机制与多维度分析输出形式',
        imgs: [
            require('@/assets/images/AISmartManagement/content5.png'),
            require('@/assets/images/AISmartManagement/content6.png'),
            require('@/assets/images/AISmartManagement/content7.png'),
        ]
    }
}